import Vue from 'vue';
import Vuetify from 'vuetify';

Vue.use(Vuetify);

const vuetify = new Vuetify({
    theme: {
      themes: {
        light: {
          // primary: '#6b6b6b',
          primary: '#53bdfb',
          secondary: '#424242',
          accent: '#82B1FF',
          error: '#FF5252',
          info: '#2196F3',
          success: '#4CAF50',
          warning: '#FFC107',

          class4: '#ffdada',
          class3: '#d4ffd9',
          class2: '#bff6ff',
          class1: '#eddfff',

          exam6: '#ffdada',
          exam5: '#d4ffd9',
          exam4: '#bff6ff',
          exam3: '#eddfff',

          semester2: '#ffdada',
          semester1: '#bff6ff',
        },
      },
    },
    lang: {
      current: 'ko' // en | es | fr | pl | ru | uk | ptbr | tr | he | nl | ja | de | ko | zhHans | fa | sv | cs | it | el
    }
  })

export default vuetify
